import React from 'react';
import styled, {createGlobalStyle} from 'styled-components';
import fetch from 'isomorphic-fetch';
import { Oval } from 'react-loader-spinner';

import '../assets/reset.css';

import FilterableEventMonthList from '../components/events/FilterableEventMonthList';
import {EventSummaryStyles}  from '../components/events/EventSummary';
import {EventTicketButtonStyles} from '../components/events/EventTicketButton';
import {ShoppingCartButtonStyles} from '../components/ShoppingCartButton';

import merchantConfig from './config/merchant-config'
const backendBaseUrl = merchantConfig.backendUrl;
const merchantId = merchantConfig.merchantId;


/* Global Styles injected in thr body-Tag */
const GlobalStyle = createGlobalStyle`
 
 

  body {
	font-family: Open Sans;
	font-size: 16px;
  }
`;


const contentWidth = '100%';

export const EventListStyles = {
	LeoContent: styled.div`
	color: black;
	width: ${contentWidth};
	margin: auto;
	@media(max-width: 768px) {
		width: 100%;
	}
	`,
	Oval:  styled.div`
		position: fixed;
		top: 0px;
		left: 0px;
		bottom: 0px;
		right: 0px;
		display: flex;
		align-items: center;
		overflow: auto;
		div: first-child {
			margin: auto;
			max-height: 100%;
		}
	`,
};

const S = EventListStyles;

// Overwrite Style(s)
EventSummaryStyles.Button = styled(EventSummaryStyles.Button)`
	color: #000000;
`;

EventTicketButtonStyles.Button = styled(EventTicketButtonStyles.Button)`
	background-color: #000000
`;

EventSummaryStyles.EventTitle = styled(EventSummaryStyles.EventTitle)`
	color: #606060;
	span {color: #606060;}
`;

EventSummaryStyles.StartOfSaleInfo = styled(EventSummaryStyles.StartOfSaleInfo)`
	color: #606060;
`;

ShoppingCartButtonStyles.Button = styled(ShoppingCartButtonStyles.Button)`
	background-color: #000000;
`;


/* Height of EventImageVideoGallery is specified be the content width
   Desktop: if content width == % it schuld be converted in vw because otherwise the height of the
   image video gallery container would be calculated wrong (height of image video container would
   be xx% from the parent container height and not from the content width)
   Mobile: mobile styles don't need to be overwritten because content width by mobile is 100% - for
   the calculation of the video image gallery container is used 100vw
*/
EventSummaryStyles.EventImageVideoGallery = styled(EventSummaryStyles.EventImageVideoGallery)`
	@media (min-width: 768px) {
		height: calc(${props => (props.height ? props.height : 1)} * (${contentWidth.indexOf('%') === -1 ? contentWidth : contentWidth.replace('%', 'vw')} / 5));
	}
`;

class EventList extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			events: [],
			showLoading: true,
		};

		fetch(new URL(`${backendBaseUrl}/api/public/v2/events/search/findByMerchantIdAndReleasedAndNotExpired?merchantId=${merchantId}&released=true&timeZoneId=ECT&distributionChannel=Programmübersicht`))
			.then(response => response.json())
			.then((responseJson) => {
				this.setState({
					events: responseJson._embedded.displayEventProjections,
					showLoading: false,
				});
			})
			.catch((error) => {
				this.setState({
					showLoading: false,
				})
				console.error(`Couldn't load events: ${error}`);
			});
	}

	componentDidMount() {
		setTimeout(() => {
			window.parent.postMessage({ height: document.body.scrollHeight }, '*');
		}, 200);
		setInterval(() => {
			window.parent.postMessage({ height: document.body.scrollHeight }, '*');
		}, 1000);
	}

	render() {
		return (
			<S.LeoContent>
				<GlobalStyle /><link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />
<link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,600,700,700i,800@display=swap" />

				{this.state.showLoading ? 
					<S.Oval>
						<Oval 
							
							color="#484646"
							height="100"	
							width="100"
						/>
					</S.Oval>
					  :
					<FilterableEventMonthList events={this.state.events} />
				}
			</S.LeoContent>
		);
	}
}

export default EventList;